export default {
  customer_disclaimer:
    "As the merchant, we will securely retain and use your personal information solely for invoicing and related purposes. Should you wish to access or amend your personal details, or have any concerns, please feel free to reach out to us.",
};
